var Point = PIXI.Point;
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
export var mapOutskirtsPosition = new Map([
    [IdOutskirtBuildings.Harbor, new Point(5580, 1760)],
    [IdOutskirtBuildings.Pier, new Point(6174, 2060)],
    [IdOutskirtBuildings.ExternalBarn, new Point(5300, 2170)],
    [IdOutskirtBuildings.Watertower, new Point(2499, 1407)],
    [IdOutskirtBuildings.Doghouse, new Point(2882, 1732)],
    [IdOutskirtBuildings.TournamentTent, new Point(2461, 1919)],
    [IdOutskirtBuildings.Nursery, new Point(3190, 1566)],
    [IdOutskirtBuildings.Library, new Point(5931, 2665)],
    [IdOutskirtBuildings.Cafe, new Point(1730, 1900)],
    [IdOutskirtBuildings.Market, new Point(4598, 2032)],
    [IdOutskirtBuildings.ThemedEvent, new Point(4192, 1629)],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/mapOutskirtsPosition.ts
// module id = 559
// module chunks = 3